import React from "react";
import { ReactComponent as VehicleIconInternal } from "resources/vehicle.svg";
import { ReactComponent as OneLinkLogoIconInternal } from "resources/1link.svg";
import { ReactComponent as DriverIconInternal } from "resources/driver.svg";
import { ReactComponent as GarageIconInternal } from "resources/garage.svg";
import { ReactComponent as JobsIconInternal } from "resources/jobs.svg";

import { ReactComponent as QuestionIconInternal } from "resources/question.svg";
import { ReactComponent as PinIconInternal } from "resources/pin.svg";
import { ReactComponent as KeyIconInternal } from "resources/key.svg";
import { ReactComponent as CalendarIconInternal } from "resources/calendar.svg";
import "components/icons/IconsStyles.scss";

export const VehicleIcon: React.FC = () => {
    return <VehicleIconInternal style={{ width: "40px" }} title="vehicle icon" />;
};

export const OneLinkLogoIcon: React.FC = () => {
    return <OneLinkLogoIconInternal style={{ minWidth: "85px" }} title="1Link logo" />;
};

export const DriverIcon: React.FC = () => {
    return <DriverIconInternal style={{ width: "28px" }} title="driver icon" />;
};

export const GarageIcon: React.FC = () => {
    return <GarageIconInternal style={{ width: "25px" }} title="garage icon" />;
};

export const JobsIcon: React.FC = () => {
    return <JobsIconInternal style={{ width: "24px" }} title="clipboard icon" />;
};

export const QuestionIcon: React.FC = () => {
    return <QuestionIconInternal style={{ width: "24px" }} title="question mark icon" />;
};

export const PinIcon: React.FC = () => {
    return <PinIconInternal style={{ width: "24px" }} title="pin icon" />;
};

export const KeyIcon: React.FC = () => {
    return <KeyIconInternal style={{ width: "29px" }} title="key icon" />;
};

export const CalendarIcon: React.FC = () => {
    return <CalendarIconInternal style={{ width: "24px" }} title="calendar icon" />;
};

export const Icons = {
    VehicleIcon: VehicleIcon,
    DriverIcon: DriverIcon,
    GarageIcon: GarageIcon,
    JobsIcon: JobsIcon,
    QuestionIcon: QuestionIcon,
};

export const CrossIcon: React.FC = () => {
    return (
        <svg className="x-icon" version="1.1" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet" viewBox="0 0 640 640">
            <defs>
                <path d="M646.15 645.05L-6.04 -5.49" id="aHFETwHJ"></path>
                <path d="" id="eJbSfRUhN"></path>
                <path d="M644.18 -3.63L-1.98 641.43" id="e5gMaaTj2L"></path>
            </defs>
            <g>
                <g>
                    <g>
                        <g>
                            <use href="#aHFETwHJ" opacity="1" fillOpacity="0" stroke="#000000" strokeWidth="60" strokeOpacity="1"></use>
                        </g>
                    </g>
                    <g>
                        <g>
                            <use href="#eJbSfRUhN" opacity="1" fillOpacity="0" stroke="#000000" strokeWidth="3" strokeOpacity="1"></use>
                        </g>
                    </g>
                    <g>
                        <g>
                            <use href="#e5gMaaTj2L" opacity="1" fillOpacity="0" stroke="#000000" strokeWidth="60" strokeOpacity="1"></use>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
};

export const LeftArrowIcon: React.FC = () => {
    return (
        <svg className="angle-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 492 492">
            <path
                d="M198.608,246.104L382.664,62.04c5.068-5.056,7.856-11.816,7.856-19.024c0-7.212-2.788-13.968-7.856-19.032l-16.128-16.12
                C361.476,2.792,354.712,0,347.504,0s-13.964,2.792-19.028,7.864L109.328,227.008c-5.084,5.08-7.868,11.868-7.848,19.084
                c-0.02,7.248,2.76,14.028,7.848,19.112l218.944,218.932c5.064,5.072,11.82,7.864,19.032,7.864c7.208,0,13.964-2.792,19.032-7.864
                l16.124-16.12c10.492-10.492,10.492-27.572,0-38.06L198.608,246.104z"
                className="angle-icon-path"
            />
        </svg>
    );
};

export const RightArrowIcon: React.FC = () => {
    return (
        <svg className="angle-icon" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 492 492">
            <path
                d="M382.678,226.804L163.73,7.86C158.666,2.792,151.906,0,144.698,0s-13.968,2.792-19.032,7.86l-16.124,16.12
                c-10.492,10.504-10.492,27.576,0,38.064L293.398,245.9l-184.06,184.06c-5.064,5.068-7.86,11.824-7.86,19.028
                c0,7.212,2.796,13.968,7.86,19.04l16.124,16.116c5.068,5.068,11.824,7.86,19.032,7.86s13.968-2.792,19.032-7.86L382.678,265
                c5.076-5.084,7.864-11.872,7.848-19.088C390.542,238.668,387.754,231.884,382.678,226.804z"
                className="angle-icon-path"
            />
        </svg>
    );
};

export const UpArrowIcon: React.FC = () => {
    return (
        <svg
            enableBackground="new 0 0 32 32"
            id="uparrowsvg"
            version="1.1"
            viewBox="0 0 32 32"
            xmlSpace="preserve"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <path
                clipRule="evenodd"
                d="M26.711,20.273l-9.999-9.977  c-0.395-0.394-1.034-0.394-1.429,0v0h0l-9.991,9.97c-0.66,0.634-0.162,1.748,0.734,1.723h19.943  C26.862,22.012,27.346,20.906,26.711,20.273z M15.998,12.433l7.566,7.55H8.432L15.998,12.433z"
                fill="#121313"
                fillRule="evenodd"
                id="Arrow_Drop_Up"
            />
            <g />
            <g />
            <g />
            <g />
            <g />
            <g />
        </svg>
    );
};

export const DownArrowIcon: React.FC = () => {
    return (
        <svg
            enableBackground="new 0 0 32 32"
            id="downarrowsvg"
            version="1.1"
            viewBox="0 0 32 32"
            xmlSpace="preserve"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <path
                clipRule="evenodd"
                d="M27,11.106c0-0.564-0.489-1.01-1.044-0.995  H6.013c-0.887-0.024-1.38,1.07-0.742,1.702l9.999,9.9c0.394,0.39,1.031,0.376,1.429,0l9.991-9.892C26.879,11.64,27,11.388,27,11.106  z M15.984,19.591L8.418,12.1H23.55L15.984,19.591z"
                fill="#121313"
                fillRule="evenodd"
                id="Arrow_Drop_Down"
            />
            <g />
            <g />
            <g />
            <g />
            <g />
            <g />
        </svg>
    );
};

export const FilterIcon: React.FC = () => {
    return (
        <svg
            version="1.1"
            id="Capa_1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            width="15px"
            height="15px"
            viewBox="0 0 971.986 971.986"
            xmlSpace="preserve"
            fill="#8a8a8a"
            style={{ marginLeft: "8px" }}
        >
            <g>
                <path
                    d="M370.216,459.3c10.2,11.1,15.8,25.6,15.8,40.6v442c0,26.601,32.1,40.101,51.1,21.4l123.3-141.3
                c16.5-19.8,25.6-29.601,25.6-49.2V500c0-15,5.7-29.5,15.8-40.601L955.615,75.5c26.5-28.8,6.101-75.5-33.1-75.5h-873
                c-39.2,0-59.7,46.6-33.1,75.5L370.216,459.3z"
                />
            </g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
        </svg>
    );
};

export const LocationIcon: React.FC = () => {
    return (
        <svg width="22px" height="22px" viewBox="0 0 22 22" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
            <title>gps_fixed</title>
            <g id="Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="Outlined" transform="translate(-543.000000, -1749.000000)">
                    <g id="Device" transform="translate(100.000000, 1650.000000)">
                        <g id="Outlined-/-Device-/-gps_fixed" transform="translate(442.000000, 98.000000)">
                            <g>
                                <polygon id="Path" points="0 0 24 0 24 24 0 24"></polygon>
                                <path
                                    d="M12,8 C9.79,8 8,9.79 8,12 C8,14.21 9.79,16 12,16 C14.21,16 16,14.21 16,12 C16,9.79 14.21,8 12,8 Z M20.94,11 C20.48,6.83 17.17,3.52 13,3.06 L13,1 L11,1 L11,3.06 C6.83,3.52 3.52,6.83 3.06,11 L1,11 L1,13 L3.06,13 C3.52,17.17 6.83,20.48 11,20.94 L11,23 L13,23 L13,20.94 C17.17,20.48 20.48,17.17 20.94,13 L23,13 L23,11 L20.94,11 Z M12,19 C8.13,19 5,15.87 5,12 C5,8.13 8.13,5 12,5 C15.87,5 19,8.13 19,12 C19,15.87 15.87,19 12,19 Z"
                                    id="location-svg-icons"
                                    fill="#495057"
                                ></path>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
};

export const VanIcon: React.FC = () => {
    return (
        <svg
            width="36px"
            id="e8txnB3psek1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 120 87"
            shapeRendering="geometricPrecision"
            textRendering="geometricPrecision"
        >
            <g id="e8txnB3psek2" transform="matrix(3.090044 0 0 3.09005 -50.722553 -112.805175)">
                <path
                    id="e8txnB3psek3"
                    d="M41.982188,37.828133L47.130163,42.578268L50.471749,43.55491L50.471749,49.57256L21.217869,50.026759L21.217872,37.82813L41.982188,37.828133Z"
                    transform="matrix(1.02683 0 0 1.0335 -0.97357 -1.470583)"
                    fill="none"
                    stroke="rgb(0,0,0)"
                    strokeWidth="1.8"
                    strokeLinejoin="round"
                />
                <path
                    id="e8txnB3psek4"
                    d="M54.714062,43.893894L45.374784,43.893894L45.374784,38.678496"
                    transform="matrix(1 0 0 0.87941 -7.292967 4.066699)"
                    fill="none"
                    stroke="rgb(0,0,0)"
                    strokeWidth="1.8"
                    strokeLinejoin="round"
                />
                <ellipse
                    id="e8txnB3psek5"
                    rx="3.5993"
                    ry="3.5993"
                    transform="matrix(0.660968 0 0 0.660967 26.125996 50)"
                    fill="rgb(255,255,255)"
                    stroke="rgb(0,0,0)"
                    strokeWidth="2.6"
                />
                <ellipse
                    id="e8txnB3psek6"
                    rx="3.5993"
                    ry="3.5993"
                    transform="matrix(0.660968 0 0 0.660967 45.042072 50)"
                    fill="rgb(255,255,255)"
                    stroke="rgb(0,0,0)"
                    strokeWidth="2.8"
                />
            </g>
            <g id="e8txnB3psek7" transform="matrix(1.200973 0 0 1.200973 -0.212845 -8.226928)">
                <path
                    id="e8txnB3psek8"
                    d="M0.847227,77.958632L0.850594,54.804287L4.870593,54.804287L12.258895,74.0486L19.749473,54.800864L23.789473,54.800864L23.786116,77.966235L21.166116,77.966234L21.303053,57.459031L13.311202,77.997295L11.111202,77.997295L3.151206,57.285608L3.31227,77.982147L0.847227,77.958632Z"
                    transform="matrix(1 0 0 1 0.000001 0.000002)"
                    fill="rgb(0,0,0)"
                    stroke="rgb(0,0,0)"
                    strokeWidth="1"
                    strokeLinecap="square"
                />
                <path
                    id="e8txnB3psek9"
                    d="M-6.222719,0C-6.317031,-5.552055,-3.386058,-8.585928,0,-8.481427C3.386058,-8.376926,6.135278,-5.843561,6.222719,0C6.31016,5.843561,3.774257,8.698383,0.011835,8.79432C-3.750587,8.890257,-6.225214,5.140185,-6.222719,0Z"
                    transform="matrix(1.277542 0 0 1.043199 36.760516 69.139464)"
                    fill="rgb(0,0,0)"
                    stroke="rgb(0,0,0)"
                    strokeWidth="1"
                />
                <path
                    id="e8txnB3psek10"
                    d="M-3.892757,0C-4.051665,-3.214425,-2.754399,-5.31431,0,-5.264069C2.754399,-5.213828,3.849271,-3.334431,3.892757,0C3.936243,3.334431,2.560029,5.206145,0,5.264069C-2.560029,5.321993,-3.855504,3.300614,-3.892757,0Z"
                    transform="matrix(1.343003 0 0 1.285876 36.768294 69.302957)"
                    fill="rgb(255,255,255)"
                    stroke="rgb(0,0,0)"
                    strokeWidth="0.8"
                />
                <path
                    id="e8txnB3psek11"
                    d="M51.239938,77.987942L49.399938,77.967942L49.397321,53.323615L51.991201,53.3121L51.969712,62.965556L51.946386,75.741293L51.239938,77.987942Z"
                    transform="matrix(1 0 0 1 0.000001 0.000001)"
                    fill="rgb(0,0,0)"
                    stroke="rgb(0,0,0)"
                    strokeWidth="1"
                />
                <path
                    id="e8txnB3psek12"
                    d="M-2.710666,0C-2.758323,-2.09857,-1.832402,-3.662552,0,-3.669825C1.832402,-3.677098,2.695175,-2.2838,2.710666,0C2.726157,2.2838,1.744744,3.696693,0,3.669825C-1.744744,3.642957,-2.772066,2.084859,-2.710666,0Z"
                    transform="matrix(2.659376 0 0 2.433972 57.418878 69.320486)"
                    fill="rgb(0,0,0)"
                    stroke="rgb(0,0,0)"
                    strokeWidth="0.5"
                />
                <path
                    id="e8txnB3psek13"
                    d="M-2.988683,0C-3.000578,-2.193561,-2.204601,-3.853328,0,-3.781032C2.204601,-3.708736,2.968925,-2.541398,2.988683,0C3.008441,2.541398,1.918534,3.770277,0,3.781032C-1.918534,3.791787,-3.00058,2.604254,-2.988683,0Z"
                    transform="matrix(1.654031 0 0 1.788314 57.001854 69.320487)"
                    fill="rgb(255,255,255)"
                    stroke="rgb(0,0,0)"
                    strokeWidth="0.6"
                />
                <path
                    id="e8txnB3psek14"
                    d="M69.335193,60.607895L71.875193,60.607895L71.916653,77.966658L69.336653,77.966658L69.335193,60.607895Z"
                    fill="rgb(0,0,0)"
                    stroke="rgb(0,0,0)"
                    strokeWidth="1"
                />
                <path
                    id="e8txnB3psek15"
                    d="M-1.325,-0.051671C-1.447941,-0.783448,-0.862673,-1.376671,0,-1.376671C0.862673,-1.376671,1.281338,-0.802674,1.325,-0.051671C1.368662,0.699332,0.772728,1.21903,0,1.273329C-0.772728,1.327628,-1.325,0.756803,-1.325,-0.051671Z"
                    transform="matrix(1.15209 0 0 1.308208 70.642203 55.904632)"
                    fill="rgb(0,0,0)"
                    stroke="rgb(0,0,0)"
                    strokeWidth="0.8"
                />
                <path
                    id="e8txnB3psek16"
                    d="M77.557404,77.944614L80.117404,77.924614L80.067585,53.353738L77.547585,53.353738L77.557404,77.944614Z"
                    transform="matrix(1 0 0 1 0.000002 0)"
                    fill="rgb(0,0,0)"
                    stroke="rgb(0,0,0)"
                    strokeWidth="1"
                />
                <path
                    id="e8txnB3psek17"
                    d="M98.721965,74.83797L98.721965,77.17797Q96.321965,78.27797,92.981965,78.31797C89.641965,78.35797,84.421965,76.49797,84.781965,68.63797C85.141965,60.77797,90.905289,60.336604,92.085289,60.296604C93.265289,60.256604,96.926763,60.633154,98.379127,63.473949C99.302924,65.280878,99.585174,67.354283,99.343449,69.738885L87.453948,69.731659Q87.677564,72.258063,88.277564,73.378063C88.877564,74.498063,90.057564,75.658063,91.697564,75.858063C93.337564,76.058063,94.297563,76.038063,95.717563,75.778063Q97.137563,75.518063,98.721965,74.83797Z"
                    transform="matrix(1 0 0 1 0.000005 0)"
                    fill="rgb(0,0,0)"
                    stroke="rgb(0,0,0)"
                    strokeWidth="1"
                />
                <path
                    id="e8txnB3psek18"
                    d="M96.64833,67.642273Q96.878345,65.109981,95.46833,63.662273C94.596658,62.767299,93.344123,62.309974,91.66833,62.502273C90.419373,62.652269,89.015126,63.489569,88.26833,64.882273C87.615233,66.100238,87.659687,66.954058,87.56833,67.582273L96.64833,67.642273Z"
                    fill="rgb(255,255,255)"
                    stroke="rgb(0,0,0)"
                    strokeWidth="1"
                />
            </g>
        </svg>
    );
};
